import React, { Fragment } from "react";
import { translate } from "../Services/translation";
import NumberInput from "./NumberInput";

const MiniCart = ({
  grandTotal,
  discount,
  paymentCost,
  deliveryCost,
  quantity,
  orderRows,
  orderTotal,
  checkoutUrl,
  showInfo,
  toggle,
  update,
}) => (
  <Fragment>
    {window.__litium.constants.eCommerseEnabled &&
      <div className="cart cart--mini">
        {quantity.length > 0 && (
          <a href="#" className="cart__link--block" onClick={() => toggle()}>
            <i className="cart__icon">
              <span className="cart__quantity">{quantity}</span>
            </i>
            <span className="cart__title">{translate("minicart.checkout")}</span>
          </a>
        )}
        <div
          className={`cart__dimmer${!showInfo ? ' cart__dimmer--hidden' : ''}`}
          onClick={() => toggle(false)}>
        </div>
        <div className={`cart__info ${!showInfo ? "cart__info--hidden" : ""}`}>
          <div className="cart__info-svg"></div>
          <div className="cart__info-container">
            <div className="cart__info-header">
              <h2>Din kurv ({quantity})</h2>
              <span
                className="cart__close-button sicon-x"
                onClick={() => toggle()}
              ></span>
            </div>
            <div className="cart__info-products">
              {orderRows &&
                orderRows.map((order) => (
                  <div
                    className="row small-unstack no-margin cart-products__row"
                    key={order.rowSystemId}
                  >
                    <div className="columns small-12 medium-6">
                      <div className="cart-products__product-info">
                        <span className="cart-products__brand-name">
                          {order.brand}
                        </span>
                        <a href={order.url}>{order.name}</a>
                        <a
                          className="table__icon table__icon--delete"
                          title={translate("general.remove")}
                        ></a>
                        <span className="cart-products__tools">
                          {/* {!order.isFreeGift && !removingRow[order.rowSystemId] && (
                        <a
                          className="table__icon table__icon--delete"
                          onClick={() =>
                            this.onDeleteRequest(order.rowSystemId, true)
                          }
                          title={translate("general.remove")}
                        ></a>
                      )}
                      {!order.isFreeGift && removingRow[order.rowSystemId] && (
                        <Fragment>
                          <a
                            className="table__icon table__icon--accept"
                            onClick={() =>
                              this.props.removeOrderRow(order.rowSystemId)
                            }
                            title={translate("general.ok")}
                          ></a>
                          <a
                            className="table__icon table__icon--cancel"
                            onClick={() =>
                              this.onDeleteRequest(order.rowSystemId, false)
                            }
                            title={translate("general.cancel")}
                          ></a>
                        </Fragment>
                      )} */}
                        </span>
                      </div>
                    </div>
                    <div className="columns small-3 medium-3">
                      {order.isFreeGift ? (<div></div>) : (
                        <NumberInput
                          count={order.quantity}
                          increase={() =>
                            update(order.rowSystemId, order.quantity + 1)
                          }
                          decrease={() =>
                            update(order.rowSystemId, order.quantity - 1)
                          }
                        />
                      )}
                    </div>
                    <div className="columns small-6 medium-3 cart-products__total-price simple-table__cell--no-break-word text-right">
                      {order.totalPrice}
                    </div>
                  </div>
                ))}
            </div>
            <div className="cart__info-rows">
              <p className="cart__info-row">
                <span>Subtotal</span>
                <span>{orderTotal}</span>
              </p>
              <p className="cart__info-row">
                <span>Levering</span>
                <span>{deliveryCost}</span>
              </p>
              <p className="cart__info-row cart__info-row--total">
                <span>
                  <b>{translate("minicart.total")}</b>
                </span>
                <span>{grandTotal}</span>
              </p>
              <div className="cart__info-row">
                <a href={checkoutUrl} className="buy-button">
                  <span className="buy-button-icon"></span>
                  {translate("minicart.checkout")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </Fragment>
);

export default MiniCart;
